import util from '../util';

export const DESKINGPAYMENTS = 'DESKINGPAYMENTS';
export const DESKINGOFFERPAYMENT = 'DESKINGOFFERPAYMENT';
export const DESKINGOFFERPAYMENT_DELETE = 'DESKINGOFFERPAYMENT_DELETE';
export const DESKINGBULKPAYMENT = 'DESKINGBULKPAYMENT';
export const DESKINGOFFERPAYMENT_CALC = 'DESKINGOFFERPAYMENT_CALC';

export const DESKINGPAYMENTS_SUCCESS = util.successType(DESKINGPAYMENTS);
export const DESKINGPAYMENTS_FAILURE = util.failureType(DESKINGPAYMENTS);

export const DESKINGOFFERPAYMENT_REQUEST = util.requestType(
  DESKINGOFFERPAYMENT,
);
export const DESKINGOFFERPAYMENT_SUCCESS = util.successType(
  DESKINGOFFERPAYMENT,
);
export const DESKINGOFFERPAYMENT_FAILURE = util.failureType(
  DESKINGOFFERPAYMENT,
);

export const DESKINGOFFERPAYMENT_DELETE_SUCCESS = util.successType(
  DESKINGOFFERPAYMENT_DELETE,
);
export const DESKINGOFFERPAYMENT_DELETE_FAILURE = util.failureType(
  DESKINGOFFERPAYMENT_DELETE,
);

export const DESKINGBULKPAYMENT_SUCCESS = util.successType(DESKINGBULKPAYMENT);
export const DESKINGBULKPAYMENT_FAILURE = util.failureType(DESKINGBULKPAYMENT);

export const DESKINGOFFERPAYMENT_CALC_START = 'DESKINGOFFERPAYMENT_CALC_START';
export const DESKINGOFFERPAYMENT_CALC_END = 'DESKINGOFFERPAYMENT_CALC_END';

export const SET_LATEST_REQUEST_DATE = 'SET_LATEST_REQUEST_DATE';
